
import { defineComponent, SetupContext, toRefs, watch, ComponentPublicInstance, ref } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "RecommendFoodNoticeToast",
  props: {
    // トースト表示 (true: 活性、false: 非活性)
    isShowToast: {
      type: Boolean,
      default: false
    },
    // メッセージ
    message: {
      type: String,
      default: ""
    }
  },
  setup(props, context: SetupContext) {
    const cardContent = ref<ComponentPublicInstance<HTMLInputElement>>();
    const fadeinAnimation = () => {
      if (cardContent.value != undefined && cardContent.value != null) {
        cardContent.value.animate(
	        [
            { opacity: 0 },
		        { opacity: 1 }
	        ],
	        {
		        duration: 500,
		        fill: 'forwards'
	        }
        );
      } else {
        NativeClient.sendDebugLog("RecommendFoodNoticeToast fadeinAnimation failed get element");
        context.emit("close-toast");
      }
    };

    const fadeoutAndEmitCloseEvent = () => {
      const arrayElement = document.getElementsByClassName("recommend-food-notice-toast-view-card");
      if (arrayElement.length > 0) {
        arrayElement[0].animate(
	      [
          { opacity: 1 },
		      { opacity: 0 }
	      ],
	      {
		      duration: 500,
		      fill: 'forwards'
	      }
        );
        // アニメーション終了後+100msでイベントを送信
        window.setTimeout(() => {
          NativeClient.sendDebugLog("RecommendFoodNoticeToast fadeoutAndEmitCloseEvent animation end!");
          context.emit("close-toast");
        }, 600);
      } else {
        NativeClient.sendDebugLog("RecommendFoodNoticeToast fadeoutAndEmitCloseEvent failed get element");
        context.emit("close-toast");
      }
    };

    // メッセージ変化の監視
    let previouShowToast = false;
    const { isShowToast } = toRefs(props);
    watch(isShowToast, () => {
      NativeClient.sendDebugLog("CommonDialog watch");
      if (isShowToast.value != previouShowToast && isShowToast.value) {
        // フェードイン・アニメーション（少し時間をずらさないと表示できないので、100ms後にフェードイン開始する）
        window.setTimeout(() => {
          NativeClient.sendDebugLog("RecommendFoodNoticeToast watch fadein animation");
          fadeinAnimation();
        }, 100);
        // 以下は、
        // // トースト表示を終了するための処理（上記で、100ms送らせているので、5s+100ms後にフェードアウト開始）
        // window.setTimeout(() => {
        //   NativeClient.sendDebugLog("RecommendFoodNoticeToast Toast close process");
        //   fadeoutAndEmitCloseEvent();
        // }, 5100);
      }
      previouShowToast = isShowToast.value;
    });

    const clickClose = () => {
      NativeClient.sendDebugLog("RecommendFoodNoticeToast close click!");
      fadeoutAndEmitCloseEvent();
    };

    return {
      cardContent,
      clickClose
    };
  }
});
